"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIRECTION_COLUMN = exports.DIRECTION_ROW = void 0;

/* eslint one-var: "off" */
var DIRECTION_ROW = 'row';
exports.DIRECTION_ROW = DIRECTION_ROW;
var DIRECTION_COLUMN = 'column';
exports.DIRECTION_COLUMN = DIRECTION_COLUMN;